<template>
  <div id="priceSize" class="page-wrap" v-loading="loading" element-loading-text="拼命加载中"
    element-loading-spinner="el-icon-loading">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>重点产品价格趋势</el-breadcrumb-item>
    </el-breadcrumb>
    <div style="padding: 20px;background-color: white;">
      <el-date-picker size="small" v-model="searchformDate" value-format="yyyy-MM-dd" type="monthrange"
        range-separator="至" start-placeholder="开始月份" end-placeholder="结束月份">
      </el-date-picker>
      <el-select size="small" v-model="procuctname" multiple placeholder="请选择产品名称" filterable
        style="margin-left: 20px;">
        <el-option v-for="item in options" :key="item" :label="item" :value="item">
        </el-option>
      </el-select>
      <el-button size="small" style="margin-left: 20px;" @click="getdataProductAnalysis">查询</el-button>
      <el-button size="small" style="margin-left: 20px;" @click="download">下载明细</el-button>
    </div>
    <div style="background-color: white;margin-top: 20px;overflow: auto;" v-loading="loading"
      element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
      <el-row style="padding-top: 60px;clear: both;">
        <el-col :span="24">
          <div id="main" style="height: 300px;width: 100%;"></div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      options: [],
      searchformDate: [],
      procuctname: [],
      loginAnalysisData: {},
      list: [],
      loading: false,
      myChart: null,
    };
  },
  mounted() {
    this.getProductName()
  },
  methods: {
    getProductName() {
      fetch({
        url: "hcm//iprViolationRetrieveData/getProductName",
        method: "get",
        noFormat: true,
        responseType: "text"
      }).then(result => {
        let res = JSON.parse(result);
        if (res.status == '10000') {
          this.options = res.data
        } else {
          this.$message({
            message: res.message,
            type: "error"
          });
        }
      }).catch(error => {
        this.$message.error('服务器错误~');
      })
    },
    getdataProductAnalysis() {
      if (this.searchformDate.length != 2 || this.procuctname.length == 0) {
        this.$message({
          message: '请选择完整时间范围和产品名称!',
          type: 'warning'
        });
        return
      }
      this.loading = true
      let params = {
        starttime: this.searchformDate[0],
        endtime: this.searchformDate[1]
      }
      if (this.procuctname.length > 0) {
        params.procuctname = this.procuctname.join(',')
      }
      fetch({
        url: "hcm/iprViolationRetrieveData/dataProductAnalysis",
        method: "get",
        params: params,
        noFormat: true,
        responseType: "text"
      }).then(result => {
        let res = JSON.parse(result);
        if (res.status == '10000') {
          this.loginAnalysisData = res.data
          this.list = res.data.List
          let series = res.data.series
          if (series.length > 0) {
            for (let a in series) {
              series[a].type = 'line'
              series[a].label = {
                show: true,
                position: 'top'
              }
            }
          }
          this.$nextTick(() => {
            this.drawChart(res.data.legend, series, res.data.xAxis)
          })
          // this.drawChart(res.data.legend, series, res.data.xAxis)
          this.loading = false
        } else {
          this.$message({
            message: res.message,
            type: "error"
          });
        }
      }).catch(error => {
        this.$message.error('服务器错误~');
        console.log(error)
        this.loading = false
      })
    },
    // 个人排名
    drawChart(legend, series, xAxis) {
      // 初始化 ECharts 实例（如果尚未初始化
      if (!this.myChart) {
        const chartDom = document.getElementById("main");
        if (!chartDom) {
          this.$message.error("找不到图表容器！");
          return;
        }
        this.myChart = this.$echarts.init(chartDom);
      }
      // 指定图表的配置项和数据
      let option = {
        tooltip: {
          trigger: 'axis',
        },
        legend: legend,
        toolbox: {
          feature: {
            saveAsImage: { show: true }
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: xAxis.date,
        },
        yAxis: [{
          type: 'value',
        }],
        series: series
      };
      // 使用刚指定的配置项和数据显示图表。
      this.myChart.setOption(option, true);
    },
    // 下载
    download() {
      if (this.searchformDate.length != 2 || this.procuctname.length == 0) {
        this.$message({
          message: '请选择完整时间范围和产品名称!',
          type: 'warning'
        });
        return
      }
      let datas = {
        starttime: this.searchformDate[0],
        endtime: this.searchformDate[1]
      }
      if (this.procuctname.length > 0) {
        datas.procuctname = this.procuctname.join(',')
      }
      fetch({
        url: "hcm/iprViolationRetrieveData/downloadProductByAll",
        method: "get",
        params: datas,
        noFormat: true,
        responseType: "blob"
      }).then((res) => {
        //下载
        let url = window.URL.createObjectURL(new Blob([res]))
        let link = document.createElement('a')
        link.style.display = 'none'
        link.href = url
        link.setAttribute('download', '重点产品价格趋势.xlsx')
        document.body.appendChild(link)
        link.click()
      })
    },
  },
};
</script>
<style>
#priceSize {
  margin: 20px;
}
</style>
<style lang="scss" scoped></style>
